import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GuardFieldOperationsView } from '../guard-field-operations.service';
import { GuardTake } from '../guard-takes.service';
import { IrrigatorParcel } from '../irrigator-parcels.service';
import { ProfileKey } from '../visor.types';

@Component({
  selector: 'app-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrl: './sidebar-menu.component.scss'
})
export class SidebarMenuComponent {
  @Input({ required: true }) profile: ProfileKey = 'public';
  @Input() irrigatorParcelsPanelVisible = true;
  @Input() irrigatorParcels: IrrigatorParcel[] = [];
  @Input() irrigatorParcelsLoading = false;
  @Input() irrigatorParcelsError = '';
  @Input() selectedIrrigatorParcelId = '';
  @Input() guardTakesPanelVisible = true;
  @Input() guardTakes: GuardTake[] = [];
  @Input() guardTakesLoading = false;
  @Input() guardTakesError = '';
  @Input() selectedGuardTakeId = '';
  @Input() guardFieldOperationsView: GuardFieldOperationsView = null;
  @Input() incidentsSummaryVisible = false;
  @Input() maintenanceSummaryVisible = false;
  @Input() publicInfoVisible = false;
  @Input() aboutRamVisible = false;

  @Output() logoutRequested = new EventEmitter<Event>();
  @Output() informationToggled = new EventEmitter<void>();
  @Output() aboutRequested = new EventEmitter<void>();
  @Output() irrigatorParcelsPanelToggled = new EventEmitter<void>();
  @Output() irrigatorParcelSelected = new EventEmitter<IrrigatorParcel>();
  @Output() guardTakesPanelToggled = new EventEmitter<void>();
  @Output() guardTakeSelected = new EventEmitter<GuardTake>();
  @Output() guardFieldOperationsRequested = new EventEmitter<GuardFieldOperationsView>();

  protected isPublicAccess(): boolean {
    return this.profile === 'public';
  }

  protected isIrrigatorAccess(): boolean {
    return this.profile === 'irrigators';
  }

  protected isGuardAccess(): boolean {
    return this.profile === 'guards';
  }

  protected isManagerAccess(): boolean {
    return this.profile === 'managers';
  }

  protected toggleInformation(): void {
    this.informationToggled.emit();
  }

  protected showAbout(): void {
    this.aboutRequested.emit();
  }

  protected toggleIrrigatorParcelsPanel(): void {
    this.irrigatorParcelsPanelToggled.emit();
  }

  protected selectIrrigatorParcel(parcel: IrrigatorParcel): void {
    this.irrigatorParcelSelected.emit(parcel);
  }

  protected toggleGuardTakesPanel(): void {
    this.guardTakesPanelToggled.emit();
  }

  protected selectGuardTake(take: GuardTake): void {
    this.guardTakeSelected.emit(take);
  }

  protected showGuardFieldOperations(view: GuardFieldOperationsView): void {
    this.guardFieldOperationsRequested.emit(view);
  }

  protected logout(event: Event): void {
    this.logoutRequested.emit(event);
  }
}
